import { Card, Col, Row, Grid, Spin } from "antd";
import BarChart from "../common/BarChart";
const { useBreakpoint } = Grid;

export const PerformanceCard = (props) => {
  const { data, year, abatementData, loading } = props;
  let total = 0;
  const screens = useBreakpoint();

  let processedData = [];

  data
    .sort((a, b) => a.InventoryYear - b.InventoryYear)
    .forEach((value, index) => {
      let idx = processedData.findIndex(
        (item) =>
          item.year.toString() === value.InventoryYear &&
          item.type === "Scope 1",
      );
      let abatement = abatementData.find(
        (item) => item.Year === value.InventoryYear,
      );

      if (idx === -1) {
        processedData.push({
          year: value.InventoryYear,
          type: "Scope 1",
          value: value.Category1CO2e,
        });
      } else {
        processedData[idx].value += value.Category1CO2e;
      }

      idx = processedData.findIndex(
        (item) =>
          item.year.toString() === value.InventoryYear &&
          item.type === "Scope 2",
      );
      if (idx === -1) {
        processedData.push({
          year: value.InventoryYear,
          type: "Scope 2",
          value: value.Category2CO2e,
        });
      } else {
        processedData[idx].value += value.Category2CO2e;
      }

      idx = processedData.findIndex(
        (item) =>
          item.year.toString() === value.InventoryYear &&
          item.type === "Scope 3",
      );
      if (idx === -1) {
        processedData.push({
          year: value.InventoryYear,
          type: "Scope 3",
          value: value.Category3CO2e,
        });
      } else {
        processedData[idx].value += value.Category3CO2e;
      }

      if (value.InventoryYear === year) {
        total += value.TotalCO2e;
      }
    });

  abatementData.forEach((value) => {
    if (Object.keys(value).length === 0) return; // skip empty object

    for (let i = 1; i <= 3; i++) {
      let idx = processedData.findIndex(
        (item) => item.year === value.Year && item.type === "Scope " + i,
      );
      if (idx === -1) {
        processedData.push({
          year: value.Year,
          type: "Scope " + i,
          value: -1 * value[i.toString()],
        });
      } else {
        processedData[idx].value -= value[i.toString()];
      }
    }

    if (value.Year === year) {
      total -= value["1"] + value["2"] + value["3"];
    }
  });

  return (
    <Card
      size="small"
      title={
        <Row>
          <Col xs={24} sm={24} md={12}>
            <h5 style={{ margin: "0px", fontSize: "17.6px" }}>
              Yearly Performance
            </h5>
          </Col>
        </Row>
      }
      style={{ width: "100%", height: screens.xl ? "100%" : "auto" }}
      className="p-1"
    >
      {loading && (
        <div
          style={{
            width: "100%",
            height: "14vh",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      )}
      <div
        style={{
          width: "100%",
          height: screens.xl ? "70%" : "10vh",
          minHeight: "180px",
          display: loading ? "none" : "block",
        }}
      >
        <BarChart
          data={processedData}
          x="year"
          y="value"
          showXAxisTitle={false}
          yAxisTitle="Net Emission (tCO2e)"
          color="type"
          style={{
            width: "100%",
            height: screens.xl ? "80%" : "25vh",
            minHeight: "160px",
            display: loading ? "none" : "block",
          }}
        />
      </div>
    </Card>
  );
};
